import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import AuthGate from './AuthGate';

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <AuthGate>
                <App />
            </AuthGate>
        </React.StrictMode>
    );
} else {
    console.error('Root element not found');
}
